import { useState, useEffect } from 'react'
import { Ga4Events } from '../../events/ga4-events'
import { ProductData } from '../../../../types/index'

export const TrackViewProducts = ({ product }: { product: ProductData }) => {
  const { upsellProducts, relatedProducts } = product ?? {}

  const [doomLoaded, setDoomLoaded] = useState(false)

  useEffect(() => {
    if (doomLoaded) {
      return
    }

    if (upsellProducts?.length) {
      Ga4Events.viewItems({
        products: upsellProducts,
        itemListName: 'Upsell Products'
      })
    }
    if (relatedProducts?.length) {
      Ga4Events.viewItems({
        products: relatedProducts,
        itemListName: 'Related Products'
      })
    }
    setDoomLoaded(true)
  }, [upsellProducts, relatedProducts, doomLoaded])

  return null
}
